import { Platform } from 'react-native';

export const isWeb = Platform.OS === 'web';
/** Punch `source` sent to the backend. */
export const punchSource: 'web' | 'mobile' = isWeb ? 'web' : 'mobile';
export const deviceName = `hrms-${Platform.OS}`;
